import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Chip } from '@mui/material';
import { MaterialBoolControl } from 'console/shared/components/fields';
import { useCallback, useEffect, useState } from 'react';
import { ColorSelection } from '../../../color-selection';
import Rainbow from 'console/images/device-settings-dialog/rainbow.svg';
import { useHelpPopupWithRef } from 'shared/hooks/ui/help-popup/help-popup-ref';
export const ParameterAndColorSelection = (props) => {
    const { label_item, check_item, name_item, group, color_item, update_item_check, update_item_color, } = props;
    const [color, setChangeColor] = useState(color_item);
    const [HelpPopup, ref, open, close] = useHelpPopupWithRef();
    // const [anchor, ref, open, close] = useRefAnchor<HTMLDivElement>();
    const handleToggle = useCallback(() => {
        if (HelpPopup != null) {
            close();
        }
        else {
            open();
        }
    }, [HelpPopup, close, open]);
    const changeColor = useCallback((color, event) => {
        setChangeColor(color.hex);
    }, [setChangeColor]);
    const setAutoColor = useCallback(() => {
        setChangeColor(undefined);
        close();
    }, [setChangeColor, close]);
    useEffect(() => {
        update_item_color(color, name_item, group);
    }, [HelpPopup]);
    return (_jsxs(Box, { gap: 2, ref: ref, children: [_jsx(MaterialBoolControl, { color: "primary", label: label_item, value: check_item, onChange: (checked) => update_item_check(checked, name_item, group) }), _jsx(Chip, { label: _jsx(Avatar, { style: { backgroundColor: color, color }, sx: { width: 18, height: 18, border: `1px solid grey` }, children: color ? 'C' : _jsx(Rainbow, {}) }), variant: "outlined", sx: {
                    border: 'none',
                }, onClick: open }), _jsx(HelpPopup, { children: _jsx(ColorSelection, { color: color ?? '', onChange: changeColor, setAuto: setAutoColor, Close: handleToggle }) })] }));
};
